import { Token } from './types';

const LINK_REGEX = /\[(?<text>[^\]]+)\]\((?<url>[^)]+)\)/;
const TEMPLATE_REGEX = /\[(?<id>[^?\]]+)\?(?<prop>\w+)=(?<value>[^\]]+)\]/;

// eslint-disable-next-line security/detect-non-literal-regexp
const SCANNER = new RegExp(
  `(?<link>${LINK_REGEX.source})|(?<template>${TEMPLATE_REGEX.source})`,
  'g',
);

export const parseRichText = (input: string): Token[] => {
  const tokens: Token[] = [];
  let lastIndex = 0;

  for (const match of input.matchAll(SCANNER)) {
    if (match.index > lastIndex) {
      tokens.push({ type: 'text', value: input.slice(lastIndex, match.index) });
    }

    const g = match.groups!;

    if (g.link !== undefined) {
      const isTemplate = g.text.includes('?') && g.text.includes('=');
      tokens.push({
        type: 'link',
        children: isTemplate ? parseRichText(`[${g.text}]`) : [{ type: 'text', value: g.text }],
        url: g.url,
      });
    } else {
      tokens.push({ type: 'template', id: g.id, prop: g.prop, value: g.value });
    }

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < input.length) {
    tokens.push({ type: 'text', value: input.slice(lastIndex) });
  }

  return tokens;
};
